import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { trackMetaPurchase } from '../../../utils/metaPixel';

const PagamentoSucesso = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const details = location.state?.paymentDetails;
    if (details) {
      if (!details.purchaseTracked && details.paymentId) {
        trackMetaPurchase({
          paymentId: details.paymentId,
          value: details.amount,
        });
      }
      setLoading(false);
    } else {
      navigate('/');
    }
  }, [location.state, navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{
        background:
          'radial-gradient(circle at top, rgba(26, 63, 46, 0.45) 0%, rgba(7, 12, 18, 1) 55%)',
      }}
      padding={2}
    >
      {loading ? (
        <CircularProgress size={50} color="primary" />
      ) : (
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 4 },
            width: '100%',
            maxWidth: 420,
            textAlign: 'left',
            borderRadius: 4,
            background: 'linear-gradient(180deg, rgba(16, 24, 33, 0.96) 0%, rgba(10, 16, 23, 0.98) 100%)',
            border: '1px solid rgba(255,255,255,0.12)',
            color: '#E8EEF5',
            boxShadow: '0 24px 60px rgba(0,0,0,0.38)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1.6 }}>
            <CheckCircleIcon sx={{ fontSize: 34, color: '#2FD67B' }} />
            <Typography variant="overline" sx={{ color: '#86DFAE', fontWeight: 700, letterSpacing: 1 }}>
              ACESSO LIBERADO
            </Typography>
          </Box>

          <Typography variant="h5" gutterBottom sx={{ fontWeight: 800, color: '#F2F7FC', lineHeight: 1.15 }}>
            Pagamento Confirmado!
          </Typography>

          <Typography variant="body1" paragraph sx={{ color: 'rgba(235, 242, 250, 0.82)', mb: 2.2 }}>
            Seu acesso ja esta ativo. Siga estes passos rapidos:
          </Typography>

          <Box sx={{ mb: 2.4 }}>
            {[
              'Abra a aba Instruções',
              'Baixe o arquivo em Arquivos',
              'Assista os vídeos de instalação',
            ].map((step, index) => (
              <Box
                key={step}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.2,
                  p: 1.2,
                  mb: 1,
                  borderRadius: 2,
                  bgcolor: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}
              >
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    bgcolor: 'rgba(47,214,123,0.15)',
                    border: '1px solid rgba(47,214,123,0.35)',
                    color: '#95E6B9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.8rem',
                    fontWeight: 800,
                    flexShrink: 0,
                  }}
                >
                  {index + 1}
                </Box>
                <Typography sx={{ color: '#E2ECF5', fontSize: '0.95rem' }}>{step}</Typography>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            color="success"
            sx={{
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              borderRadius: 2.5,
              boxShadow: '0 12px 28px rgba(47, 214, 123, 0.26)',
              textTransform: 'none',
              fontWeight: 800,
            }}
            onClick={() => navigate('/painel')}
          >
            Ir para o painel agora
          </Button>
        </Paper>
      )}
    </Box>
  );
};

export default PagamentoSucesso;
